import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Actions
import { logout, logOutAs, loginAs } from '../../../actions/auth'
import { setLanguage, getLanguageInfos, getLanguageInfo } from '../../../language/actions'
import { myPageInformation } from '../../../actions/mypage'
import { getSupportLink } from '../../../actions/common'

// import styles
import './usermenu.scss'

// Utils
import { hasAccess, hasSubscriptionPermission, isLoginFromChainOrSuper, isLoginFromWP } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// Components
import HelpText from '../HelpText'
// import Icon from '../../elements/icon'
// import { HeaderIcons } from '../../elements/icons'

// Elements
import Divider from '../../elements/divider'
import DropDown from '../../elements/dropDown'

class UserMenu extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false,
      isLanguageOpen: false,
      myPage: {
        Orders: 0,
        Tasks: 0,
        Messages: 0
      },
      countdown: 0
      // selectedShop: 0
    }
    this.toggleMenu = this.toggleMenu.bind(this)
    this.toggleLanguageMenu = this.toggleLanguageMenu.bind(this)
    this.signOut = this.signOut.bind(this)
    this.changeLanguage = this.changeLanguage.bind(this)
    this.changeLanguageInfo = this.changeLanguageInfo.bind(this)
    this.handle = this.handle.bind(this)
    this.renderShopSelector = this.renderShopSelector.bind(this)
    this.renderName = this.renderName.bind(this)
    this.timer = undefined
  }

  componentDidMount () {
    document.addEventListener('click', this.handle, true)
    this.startTimer()
    // this.setState({
    //   selectedShop: Number(this.props.auth.user.ShopId)
    // })
  }

  componentWillUnmount () {
    document.removeEventListener('click', this.handle, true)
    clearInterval(this.timer)
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.loginTimer.getTime() !== this.props.loginTimer.getTime()) {
      this.startTimer()
    }
    // console.log('this.props.auth.user.ShopId ', this.props.auth.user.ShopId)
    // if (nextProps.auth.user.ShopId !== this.props.auth.user.ShopId) {
    //   this.setState({
    //     selectedShop: Number(nextProps.auth.user.ShopId)
    //   })
    // }
  }

  startTimer () {
    if (!hasAccess([3], this.props.auth.user.UserType) || this.props.auth.inactiveUsers.length === 0) return null
    // console.log('this.props.auth.inactiveUsers.length ', this.props.auth.inactiveUsers.length)
    clearInterval(this.timer)
    this.timer = setInterval(() => {
      let now = window.CustomDate()
      let diff = Math.floor((this.props.loginTimer.getTime() - now.getTime()) / 1000)
      if (diff <= 0) diff = 0
      this.setState({
        countdown: diff
      })
    }, 1000)
  }

  handle (e) {
    const el = this.refs.container1
    if (!el.contains(e.target) && this.state.isOpen) this.toggleMenu({ target: false })
  }

  toggleMenu (open) {
    open = (typeof open.target !== 'undefined') ? !this.state.isOpen : open
    this.setState({
      isOpen: open
    }, () => {
      if (this.state.isOpen) {
        this.getMyPageInformation()
      }
    })
  }

  toggleLanguageMenu (open) {
    open = (typeof open.target !== 'undefined') ? !this.state.isLanguageOpen : open
    this.setState({
      isLanguageOpen: open
    })
  }

  getMyPageInformation () {
    if (!hasAccess([3], this.props.auth.user.UserType)) return null
    this.props.myPageInformation(0).then((res) => {
      this.setState({
        myPage: res.data
      })
    })
  }

  signOut (e) {
    e.preventDefault()
    this.toggleMenu({ target: false })
    if (this.props.auth.inactiveUsers.length === 0) {
      this.props.logout()
      this.props.router.push('/login')
    } else {
      this.props.logOutAs().then(() => {
        this.props.router.push('/')
      })
    }
  }

  changeLanguage (e) {
    e.preventDefault()
    this.toggleMenu({ target: false })
    let lang = (window.localStorage.getItem('user_language') === 'English') ? 'Danish' : 'English'
    this.props.setLanguage(lang)
  }

  changeLanguageInfo (langInfo) {
    this.toggleLanguageMenu({ target: false })
    let lang = langInfo.LanguageName
    this.props.setLanguage(lang)
  }

  // renderMessages () { // Moved to layout with other header info
  //   if (this.props.headerInfo.UnreadMessages === 0) return null
  //   return (
  //     <div className='notification'>
  //       <Link to='/mypage/messages' onClick={this.toggleMenu.bind(this, false)}>
  //         <Icon size='m' icon={HeaderIcons.Message_With_Circle_White} />
  //       </Link>
  //     </div>
  //   )
  // }

  // renderTasks () {  // Moved to layout with other header info
  //   if (!hasSubscriptionPermission(this.props.auth, 30) || this.props.headerInfo.IncompletedTasks === 0) return null
  //   return (
  //     <div className='notification'>
  //       <Link to='/mypage/tasks' onClick={this.toggleMenu.bind(this, false)}>
  //         <Icon size='m' icon={HeaderIcons.Task_With_Circle_White} />
  //       </Link>
  //     </div>
  //   )
  // }

  renderTimeLeft () {
    if (!hasAccess([3], this.props.auth.user.UserType) || this.props.auth.inactiveUsers.length === 0 || isLoginFromChainOrSuper(this.props.auth.inactiveUsers) || (hasAccess([3], this.props.auth.user.UserType) && isLoginFromWP(this.props.auth.inactiveUsers))) return null
    return (
      <div className='user__timer'>
        {translation('1891')} {this.state.countdown}
      </div>
    )
  }

  renderShopSelector () {
    if (!hasAccess([7], this.props.auth.user.UserType) || this.props.auth.inactiveUsers.length === 0) return null
    if (this.props.companies.length === 1) return null
    const onChange = (e) => {
      // e.preventDefault()
      // window.localStorage.setItem('workscreen_view', null)
      this.props.loginAs(0, e.target.value).then((res) => {
        this.toggleMenu({ target: false })
        setTimeout(() => {
          this.props.router.replace('/empty')
          this.props.router.replace('/workscreen')
        }, 2000)
      }, () => {
        window.toastr.error(translation('1892'), translation('216'))
      })
    }
    // console.log('this.state.selectedShop ', this.state.selectedShop)
    return ([
      <Divider key='shop1' />,
      <div key='shop2' className='menu shop__selector form'>
        <DropDown value={Number(this.props.auth.user.ShopId)} key={'shopselector_' + this.props.auth.user.ShopId} onChange={onChange}>
          {this.props.companies.map((val, key) => {
            return <option key={key} value={val.ShopId}>{val.ShopName}</option>
          })}
        </DropDown>
      </div>
    ])
  }

  renderChainShopSelector () {
    // this.props.auth.inactiveUsers
    if (!hasAccess([2], this.props.auth.user.UserType)) return null
    let companies = this.props.companies.filter((company) => {
      return company.Active ? company : false
    })
    if (companies.length === 0) return null
    const onChange = (e) => {
      // e.preventDefault()
      if (e.target.value !== '0') {
        this.props.loginAs(0, parseInt(e.target.value)).then((res) => {
          this.toggleMenu({ target: false })
          this.props.router.replace('/empty')
          this.props.router.replace(res.data.StartScreen)
        }, () => {
          window.toastr.error(translation('1892'), translation('216'))
        })
      }
    }
    return ([
      <Divider key='chain1' />,
      <div key='chain2' className='menu shop__selector form'>
        <DropDown value={this.props.auth.user.ShopId} key={'shopselector_' + this.props.auth.user.ShopId} onChange={onChange}>
          <option value='0'>{translation('1896')}</option>
          {companies.map((val, key) => {
            return <option key={key} value={val.ShopId}>{val.ShopName}</option>
          })}
        </DropDown>
      </div>
    ])
  }

  renderName (extraClass) {
    // let twoLines = extraClass || ''
    let lastPartOfName = this.props.auth.user.ShopName || ''
    if (this.props.auth.user.CustomerName !== null) lastPartOfName = this.props.auth.user.CustomerName || ''

    // if (lastPartOfName !== '') twoLines += ' two-lines'

    return (
      <div className='user-info'>
        <span className='user'>{this.props.auth.user.ContactName || 'Unknown'}</span>
        {lastPartOfName && <span className='company'>{lastPartOfName}</span>}
      </div>
    )

    // return <span className={twoLines}><span>{this.props.auth.user.ContactName || 'Unknown'}</span> {lastPartOfName && <br />}<span className='company'>{lastPartOfName}</span></span>
  }
  renderVersion () {
    let localVersion = window.localStorage.getItem('clientVersion')
    let clientBuild = window.localStorage.getItem('clientBuild')
    clientBuild += ' width: ' + window.innerWidth + ', height: ' + window.innerHeight
    return (
      <div className='right'>
        {localVersion} <HelpText text={clientBuild} />
      </div>
    )
  }
  renderShop () {
    let text = translation('14864')
    let shopName = this.props.auth.user.ShopName
    let number = this.props.auth.user.ForsiBodyShopId
    if (hasAccess([4], this.props.auth.user.UserType) && (this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2)) {
      text = translation('14934')
    } else if (!hasAccess([4], this.props.auth.user.UserType) && (this.props.auth.departmentType === 1 || this.props.auth.departmentType === 2) && this.props.auth.hasPartner) {
      shopName = this.props.auth.partnerName
      number = this.props.auth.partnerForsiBodyShopId
    }
    return (
      <div className='booking'>
        <img className='bookingimage' src={'/images/svgs/listheader/pick-up-time.svg'} />
        <div>
          <div className='support text'>{translation(text)}</div>
          <div className='text'>{shopName}</div>
          {number && (<div className='text'><span>{translation('14803')}</span>: <span>{number}</span></div>)}
        </div>
      </div>
    )
  }
  support (isSupportUser) {
    let isQuarsMenmber = (this.props.auth.user.ChainId === 2 || this.props.auth.user.ChainId === '2')
    let showSupportAccess = hasAccess([3, 7], this.props.auth.user.UserType)
    return (
      <div className='supportsection'>
        <Link className='support' onClick={() => this.props.getSupportLink().then(res => window.open(res.data))}>
          <img className='supportimage' src={'/images/help-guide.svg'} />
          <div className='text bold'>{translation('16396')}</div>
        </Link>
        {isQuarsMenmber && (
          <div>
            <Link className='support' target='_blank' to={'https://898.tv/apromaslakexpertensupport'} >
              <img className='supportimage' src={'/images/Q-grey.svg'} />
              <div className='text bold'>{translation('Fjernsupport')}</div>
            </Link>
            <p className='textphone'>{'+45 70 70 72 85'}</p>
          </div>
        )}
        {showSupportAccess && !isSupportUser && (
          <Link className='support' to='/supportaccess' onClick={this.toggleMenu}>
            <img className='supportimage' src='/images/svgs/menuicons/Employees-black.svg' />
            <span>{translation('17967')}</span>
          </Link>
        )}
      </div>
    )
    // return (
    //   <div className='support'>
    //     <li className='clearfix help-guides'>
    //       <img className='supportimage' src={'/images/help-guide.svg'} />
    //       <button onClick={() => this.props.getSupportLink().then(res => window.open(res.data))}>{translation('16396')}</button>
    //     </li>
    //     {isQuarsMenmber && <li>
    //       <Link target='_blank' to={'https://898.tv/apromaslakexpertensupport'}>
    //         <img className='supportimage' src={'/images/Q-logo.svg'} />
    //         <div className='text bold'>{translation('Fjernsupport')}</div>
    //       </Link>
    //       <p className='textphone'>{'+45 70 70 72 85'}</p>
    //     </li>}
    //   </div>
    // )
  }

  renderPasswordAndPinCodeSection (isSupportUser) {
    if (!isSupportUser) {
      return (
        <div>
          <Divider />
          <div className='menu'>
            <Link className='changepassword' to='/changepassword' onClick={this.toggleMenu}>
              <img className='hardcodedimage' src='/images/svgs/menuicons/Change_password.svg' />
              <span>{translation('1777')}</span>
            </Link>
          </div>
          {hasAccess([3], this.props.auth.user.UserType) && (
            <div className='menu'>
              <Link className='changepassword' to='/changepin' onClick={this.toggleMenu}>
                <img className='hardcodedimage' src='/images/svgs/menuicons/Change_password.svg' />
                <span>{this.props.auth.user.UserHasPincode ? translation('17961') : translation('17977')}</span>
              </Link>
            </div>
          )}
        </div>
      )
    }
  }

  render () {
    let isSupportUser = this.props.auth.user.IsSupportUser
    let usermenu = ''
    let activeClass = ''
    let triggerClass = 'fa fa-chevron-right'
    const renderMyPageSection = () => {
      if (!hasAccess([3], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 20, 0)) return null
      let myOrdersEntry = ''
      if (hasSubscriptionPermission(this.props.auth, 20)) {
        myOrdersEntry = (
          <Link className='line' to='/mypage/orders' onClick={this.toggleMenu}>
            <img src='/images/svgs/menuicons/order-orderlist.svg' />
            <span>{translation('1888')}</span>
            <span className='number'>{this.state.myPage.Orders}</span>
          </Link>
        )
      }

      let myTasksEntry = ''
      if (hasSubscriptionPermission(this.props.auth, 20, 0)) {
        myTasksEntry = (
          <Link className='line' to='/mypage/tasks' onClick={this.toggleMenu}>
            <img src='/images/svgs/menuicons/Task-Black.svg' />
            <span>{translation('1889')}</span>
            <span className='number'>{this.state.myPage.Tasks}</span>
          </Link>
        )
      }
      let myMessagesEntry = ''
      if (hasSubscriptionPermission(this.props.auth, 20)) {
        myMessagesEntry = (
          <Link className='line' to='/mypage/messages' onClick={this.toggleMenu}>
            <img src='/images/svgs/menuicons/Messages-Black.svg' />
            <span>{translation('1243')}</span>
            <span className='number'>{this.state.myPage.Messages}</span>
          </Link>
        )
      }
      // <a className='nohover'>
      //   <img src='/images/svgs/menuicons/Employees-VS.svg' />
      //   <strong>{translation('1887')}</strong>
      // </a>
      return ([
        <Divider key='mypage1' />,
        <div key='mypage2' className='menu myPage'>
          {myOrdersEntry}
          {myTasksEntry}
          {myMessagesEntry}
        </div>
      ])
    }

    const renderLangNames = (val, key) => {
      return (
        <div key={key} className='langname'>
          <a onClick={this.changeLanguageInfo.bind(this, val)} href='#'>
            <img src={val.Image} />
            <label>{val.SelfLangName}</label>
          </a>
        </div>
      )
    }
    let showSupport = hasAccess([4], this.props.auth.user.UserType) || hasAccess([3], this.props.auth.user.UserType) || hasAccess([7], this.props.auth.user.UserType)
    let showPaintCompanyInfo = hasAccess([4], this.props.auth.user.UserType) || (this.props.auth.departmentType === 1 && this.props.auth.hasPartner)
    if (this.state.isOpen) {
      activeClass = 'open'
      triggerClass = 'fa fa-chevron-down'
      let languageTriggerClass = 'fa fa-chevron-right'
      let activeLangItem = window.localStorage.getItem('user_language')
      let langInfo = this.props.getLanguageInfo(activeLangItem)
      let languageMenu = null
      let currentLanguage = (
        <span>
          <img src={langInfo.Image} />
          <label><a className='language nohover'>{langInfo.SelfLangName}</a></label>
        </span>
      )
      if (this.state.isLanguageOpen) {
        currentLanguage = null
        languageTriggerClass = 'fa fa-chevron-down'
        let langInfos = this.props.getLanguageInfos()
        languageMenu = (
          langInfos.map(renderLangNames)
        )
      }
      usermenu = (
        <div className='dropdown__menu'>
          <div className='menu title'>
            <div className='left'>
              {this.renderName('dropdown__name')}
            </div>
          </div>
          {showSupport === true && ([
            <Divider key='sup1' />,
            <div key='sup2' className='menu'>
              {showPaintCompanyInfo === true && this.renderShop()}
              {this.support(isSupportUser)}
            </div>
          ])}
          <Divider />
          <div className='menu languages'>
            <div className='currentLanguage' onClick={this.toggleLanguageMenu}>
              <div className='language_trigger'>{translation('2146')} <i className={languageTriggerClass} /></div>
              {currentLanguage}
            </div>
            {languageMenu}
          </div>
          {renderMyPageSection()}
          {this.renderShopSelector()}
          {this.renderChainShopSelector()}
          {this.renderPasswordAndPinCodeSection(isSupportUser)}
          <Divider />
          <div className='menu last'>
            <a href='#' onClick={this.signOut} className='logout'>
              <img src='/images/svgs/menuicons/Logout-black.svg' />
              <span>{translation('267')}</span>
            </a>
            {this.renderVersion()}
          </div>
        </div>
      )
    }
    return (
      <div className={'user__menu ' + activeClass} ref='container1'>
        {this.renderTimeLeft()}
        { /* this.renderMessages() Moved to layout */ }
        { /* this.renderTasks() Moved to layout */ }
        <div onClick={this.toggleMenu} className='trigger'>{this.renderName()} <i className={triggerClass} /></div>
        {usermenu}
      </div>
    )
  }

}

UserMenu.propTypes = {
  logout: PropTypes.func.isRequired,
  setLanguage: PropTypes.func.isRequired,
  getLanguageInfos: PropTypes.func.isRequired,
  getLanguageInfo: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    headerInfo: state.common.headerInfo,
    loginTimer: state.common.loginTimer,
    companies: state.common.companies
  }
}

export default connect(mapStateToProps, {
  logout,
  setLanguage,
  getLanguageInfos,
  getLanguageInfo,
  myPageInformation,
  logOutAs,
  loginAs,
  getSupportLink
})(UserMenu)



// WEBPACK FOOTER //
// ./src/app/shared/components/UserMenu/index.js